import angular from 'angular';
import emailAttachmentsField from './emailAttachmentsField';
import './style.scss';

export default angular
  .module('emailAttachmentsField', [])
  .component('emailAttachmentsField', emailAttachmentsField).name;
